module.exports = __webpack_public_path__ + "static/media/logo_mcti.484b5889.png";